module.exports = __webpack_public_path__ + "static/media/Secure.c6a8514a.png";